// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zhvCW","colMin":"styles_colMin__tDcVd"};